<template>
    <div>
        <plans v-if="step == 0" :plans="plans" @setPlan="selectPlan"></plans>
        <methods v-if="step == 1" @goBack="goBack" @setMethod="setMethod"></methods>
        <checkout v-if="step == 2" :method="method" :plan="plan" :plans="plans" @goBack="goBack"></checkout>
    </div>
</template>

<script>
import Plans from './Plans';
import Methods from './Methods';
import Checkout from './Checkout';
export default {
    props: ['plans'],
    components: {
        Plans,
        Methods,
        Checkout
    },
    data() {
        return {
            step: 0,
            fk_plan: null,
            method: '',
            plan: null,
        }
    },
    methods: {
        selectPlan(id) {
            this.fk_plan = id;
            this.plan = this.plans.find(x => x.id == id);
            this.step++;
        },
        setMethod(method) {
            this.method = method;
            this.step++;
        },
        goBack() {
            this.step--;
        }
    }
}
</script>
